// @flow
import Axios from 'axios'
import moment from 'moment'
import {getCookie} from '../../utils/common';

// chart
export const UPDATE_CHART_DATA = 'earnings:updateChartData'
export type UPDATE_CHART_DATA_TYPE = {
  type: 'earnings:updateChartData',
  payload: { earningsByDate: Object[] }
}

export const updateChartData = (earningsByDate: Object[]): UPDATE_CHART_DATA_TYPE => ({
  type: UPDATE_CHART_DATA,
  payload: { earningsByDate }
})

// upcoming all earnings list
export const UPDATE_LIST_DATA = 'earnings:updateListData'
export type UPDATE_LIST_DATA_TYPE = {
  type: 'earnings:updateListData',
  payload: { upcomingEarningsTargets: Object[] }
}

export const updateListData = (upcomingEarningsTargets: Object[]): UPDATE_LIST_DATA_TYPE => ({
  type: UPDATE_LIST_DATA,
  payload: { upcomingEarningsTargets }
})

// past company earnings list
export const UPDATE_PAST_EARNINGS = 'earnings:updatePastEarnings'
export type UPDATE_PAST_EARNINGS_TYPE = {
  type: 'earnings:updatePastEarnings',
  payload: { pastEarningsTargets: Object[] }
}

export const updateEarningsHistory = (pastEarningsTargets: Object[]): UPDATE_PAST_EARNINGS_TYPE => ({
  type: UPDATE_PAST_EARNINGS,
  payload: { pastEarningsTargets }
})

// fetching status and error
export const UPDATE_EARNINGS_STATUS = 'earnings:updateEarningsStatus'
export type UPDATE_EARNINGS_STATUS_TYPE = {
  type: 'earnings:updateEarningsStatus',
  payload: { 
    isFetching: boolean,
    error: null | string
  }
}

export const updateEarningsStatus = (isFetching: boolean, error: null | string): UPDATE_EARNINGS_STATUS_TYPE => ({
  type: UPDATE_EARNINGS_STATUS,
  payload: { 
    isFetching,
    error
  }
})

// data for earnings chart
export const getDataChart = (dispatch: Function) => {
  const apiUrl = getCookie('apiUrl') || 'https://api.optionsedu.com/graphql'
  // set fetching
  dispatch(updateEarningsStatus(true, null))

  // GraphQL
  const query: Object = {
    query: `{
    market {
      earnings {
        earningsByDate {
          date
          announcements {
            symbol
            confirmed
            releaseToD
            name
            estimatedEPS
          }
        }
      }
      }
    }`
  }

  const CONTENT_TYPE = { 'Content-Type': 'application/x-www-form-urlencoded' }

  Axios.post(apiUrl, query, { headers: CONTENT_TYPE })
    .then((res: Object) => {
      
      // set fetching false and add data
      dispatch(updateEarningsStatus(false, null))
      dispatch(updateChartData(res.data.data.market.earnings.earningsByDate))
    })
    .catch((err: Object) => {

      // set fetching false and add error      
      dispatch(updateEarningsStatus(false, 'Unable to Get Earnings Data'))
    })
}

// data for earnings list
export const getDataList = (dispatch: Function) => {
  const apiUrl = getCookie('apiUrl') || 'https://api.optionsedu.com/graphql'
  const query: Object = {
    query: `{
    market {
      earnings {
        upcomingEarningsTargets {
          symbol
          name
          earningsDate
          confirmed
          releaseToD
          isComplete
          source
        }
      }
      }
    }`
  }

  const CONTENT_TYPE = { 'Content-Type': 'application/x-www-form-urlencoded' }

  Axios.post(apiUrl, query, { headers: CONTENT_TYPE })
    .then((res: Object) => {

      // remove duplicates by symbol & sort by days to expiration
      const data: Object[] = res.data.data.market.earnings.upcomingEarningsTargets
      const sort: Object[] = data.sort((a: Object, b: Object): number => +moment(b.earningsDate) - +moment(a.earningsDate))
      const filtered: Object[] = Array.from(sort.reduce((a: Object, b: Object): Map<string, Object> => a.set(b.symbol, b), new Map()).values())
      const resort: Object[] = filtered.sort((a: Object, b: Object): number => +moment(a.earningsDate) - +moment(b.earningsDate))

      dispatch(updateListData(resort))
    })
    .catch((err: Object) => console.error(err))
}

// data for company past earnings history
export const getPastEarnings = (dispatch: Function, symbol: string) => {
  const apiUrl = getCookie('apiUrl') || 'https://api.optionsedu.com/graphql'
  const query: Object = {
    query: `{
    market {
      earnings {
        earningsHistory(symbols: ["${symbol}"]) {
          earningsEvents {
            confirmed
            earningsDate
            estimatedEPS
            fiscalEndDate
            fiscalQuarter
            releaseToD
            reportedEPS
            source
            surpriseAmount
            time
          }
        }
      }
      }
    }`
  }

  const CONTENT_TYPE = { 'Content-Type': 'application/x-www-form-urlencoded' }

  Axios.post(apiUrl, query, { headers: CONTENT_TYPE })
    .then((res: Object) => {

      // format data and dispatch to redux
      let data: Object[] = []
      const pastEarnings: Object[] = res.data.data.market.earnings.earningsHistory[0].earningsEvents
      pastEarnings.forEach((earning: Object, i: number) => {

        // convert to handle null
        const release: string = earning.releaseToD === 'Unknown' ? '--' : earning.releaseToD
        const estimated: string = earning.estimatedEPS === null ? '--' : `$${earning.estimatedEPS}`
        const reported: string = earning.reportedEPS === null ? '--' : `$${earning.reportedEPS}`
        const surprise: string = earning.surpriseAmount === null ? '--' : (earning.surpriseAmount > 0 ? `+${earning.surpriseAmount}%` : `${earning.surpriseAmount}%`)

        // set data
        data = [
          ...data,
          {
            'fiscalPeriod': earning.fiscalQuarter,
            'earningsDate': moment(earning.earningsDate).format('M/D/Y'),
            'earningsDateFull': earning.earningsDate,
            'releaseToD': release,
            'estimatedEPS': estimated,
            'reportedEPS': reported,
            'surpriseAmount': surprise,
            'key': i
          }
        ]
      })

      // sort by earnings date and dispatch
      data.sort((a: Object, b: Object) => +moment(b.earningsDateFull) - +moment(a.earningsDateFull))
      dispatch(updateEarningsHistory(data))
    })
    .catch((err: Object) => console.error(err))
}



// WEBPACK FOOTER //
// ./src/actions/earnings/index.js